import React from 'react';

import { Grid, Typography, Card, CardMedia, Link, IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const UserListingInfoBar = ({ listing, isUserListing }: { listing; isUserListing?: boolean }) => {
  return (
    <Grid
      item
      xs={12}
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ width: '100%' }}
    >
      <Card sx={{ width: 100, marginRight: 2 }}>
        <CardMedia component="img" height="60" image={listing.thumbnail_url} alt="Listing Image" />
      </Card>

      <Typography variant="h6">
        {listing.name}{' '}
        <Link
          href={'https://www.airbnb.com/rooms/' + listing.listingID}
          target="_blank"
          rel='nofollow'
          sx={{ textDecoration: 'none' }}
        >
          <IconButton sx={{ padding: 0 }}>
            <OpenInNewIcon
              sx={{
                fontSize: 18,
              }}
            />
          </IconButton>
        </Link>
        <br />
        {isUserListing && <Typography color="textSecondary">{listing.smart_location}</Typography>}
      </Typography>
    </Grid>
  );
};

export default UserListingInfoBar;
